// extracted by mini-css-extract-plugin
export default {"row":"TerritoryHeader_row__uBDOn","title":"TerritoryHeader_title__FLGWH","button":"TerritoryHeader_button__jpG+B"};